import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/base/ComicCard';
import { categories, comics } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'hot');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const filteredComics = activeSlug === 'hot'
    ? [...comics].sort((a, b) => b.rating - a.rating)
    : comics.filter((c) => c.category === activeSlug);

  return (
    <>
      <Navbar />
      <main className="pt-20 pb-14 bg-background-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6">
            <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
            <span className="text-foreground-300">/</span>
            <span className="text-foreground-700 font-medium">{currentCategory?.name || '分类浏览'}</span>
          </nav>

          <div className="flex items-center gap-3 mb-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`${currentCategory?.icon || 'ri-grid-line'} text-xl text-primary-500`}></i>
            </div>
            <h1 className="text-xl md:text-2xl font-heading text-foreground-900">
              {currentCategory?.name || '分类浏览'}
            </h1>
          </div>
          <p className="text-sm text-foreground-500 mb-6 ml-9">
            共 {filteredComics.length} 部漫画
          </p>

          <div className="flex flex-wrap gap-2 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>

          {filteredComics.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {filteredComics.map((comic) => (
                <ComicCard
                  key={comic.id}
                  id={comic.id}
                  title={comic.title}
                  author={comic.author}
                  rating={comic.rating}
                  status={comic.status}
                  updateChapter={comic.updateChapter}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-inbox-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">暂无该分类的漫画</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          'name': `${currentCategory?.name || '分类'} - 虫虫漫画网`,
          'description': `虫虫漫画网${currentCategory?.name || ''}分类，提供海量无删减韩国漫画免费阅读，下拉观看流畅不卡顿。`,
          'url': `https://www.chongchongmanhua.com/category/${activeSlug}`,
          'breadcrumb': {
            '@type': 'BreadcrumbList',
            'itemListElement': [
              { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://www.chongchongmanhua.com/' },
              { '@type': 'ListItem', 'position': 2, 'name': currentCategory?.name || '分类浏览', 'item': `https://www.chongchongmanhua.com/category/${activeSlug}` }
            ]
          }
        })
      }} />
    </>
  );
}